<template>
  <div id="app" v-if="!isMobile"  style="width: 100%;height: 100vh; " @wheel.prevent="handleWheel">
    <VideoBackground></VideoBackground>
    <div style="position:relative;width:100%;height:100%">
      <img src="../../public/1bg.png" alt="" style="width:100%;height:100vh">
      <img src="../../public/1bt.png" alt="" style="position:absolute;top:85%;left:50%;margin-left:-90px;width:180px;cursor: pointer;">
    </div>
    <div style="position:relative;width:100%;height:100%">
      <img src="../../public/2bg.png" alt="" style="width:100%;height:100vh">
      <img src="../../public/2bt.png" alt="" style="position:absolute;top:85%;left:50%;margin-left:-90px;width:180px;cursor: pointer;">
    </div>
    <div style="position:relative;width:100%;height:100%">
      <img src="../../public/3bg.png" alt="" style="width:100%;height:100vh">
      <img src="../../public/3bt.png" alt="" style="position:absolute;top:85%;left:50%;margin-left:-90px;width:180px;cursor: pointer;">
    </div>
    <div style="position:relative;width:100%;height:100%">
      <img src="../../public/4bg.png" alt="" style="width:100%;height:100vh">
      <img src="../../public/4bt.png" alt="" style="position:absolute;top:85%;left:25%;margin-left:-90px;width:180px;cursor: pointer;">
    </div>
    <div style="position:relative;width:100%;    background: #292f33;">
      <img src="../../public/5bg.png" alt="" style="width:100%;">
      <img src="../../public/5bt.png" alt="" style="position:absolute;top:85%;left:50%;margin-left:-90px;width:180px;cursor: pointer;">
    </div>

    
    <div class="newblackdiv" style="background-color: #292f33;">
      <div style="display: flex;color:white;justify-content: space-evenly;font-size: 0.75vw;">
         <div  v-if="isEnglish" style="width: 16vw;">&emsp;&emsp;  Specializing in mobile game distribution for both domestic and overseas markets, we offer a one-stop solution coveringproduct selection & evaluation, localized adaptation, and global promotion & operation, empowering developers to achieve dual-track growth in domestic and international markets
      </div>
         <div v-else style="width: 16vw;">&emsp;&emsp;专注于国内与海外市场的手机游戏发行，提供从产品筛选评估、本地化调优到全球推广运营的一站式解决方案，助力开发者实现国内外双轨增长</div>
        
        
         <div style="">
          <div style="display: flex;flex-direction: column;    width: 24vw;">
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Record Number:</div>
              <div v-else>备案号：</div>
              <div>粤ICP备2023152724号-1</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Company:</div>
              <div  v-else>公司名：</div>
              <div  v-if="isEnglish">Shenzhen Youdian Fun Technology Co.,Ltd</div>
              <div v-else >广州好好玩科技有限公司</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">Address：</div>
              <div  v-else>地址：</div>
              <div  v-if="isEnglish" style="text-align: right;">‌Room 807, Building 4, Chongwen Garden‌
‌Nanshan District, Shenzhen City, Guangdong Province, China</div>
              <div v-else>广州市天河区棠下荷光一横路1号406</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">URL：</div>
              <div v-else>网址：</div>
              <div>www.fungamebox.cn</div>
            </div>
          </div>
      </div>
      </div>
       
      <div style="border: 0.1px solid #404040;margin: 40px 0;margin-bottom: 20px;"></div>
      <div  v-if="isEnglish" class="bottom">www.fungamebox.cn Record Number：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备2023152724号-1</a></div>
      <div v-else class="bottom">www.fungamebox.cn 备案号：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备2023152724号-1</a></div>
    </div>

  </div>
 

  <div id="app" v-else  style="width: 100%;height: 100vh; " @wheel.prevent="handleWheel">
    <PhoneVideoBackground></PhoneVideoBackground>
    <div style="position:relative;width:100%; display:flex;flex-direction: column;">
      <img src="../../public/1bg.png" alt="" style="width:100%; ">
      <!-- <img src="../../public/1bt.png" alt="" style="position:absolute;top:85%;left:50%;margin-left:-90px;width:30px;cursor: pointer;"> -->
    <!-- </div> -->
    <!-- <div style="position:relative;width:100%; "> -->
      <img src="../../public/2bg.png" alt="" style="width:100%; ">
      <!-- <img src="../../public/2bt.png" alt="" style="position:absolute;top:85%;left:50%;margin-left:-90px;width:180px;cursor: pointer;"> -->
    <!-- </div> -->
    <!-- <div style="position:relative;width:100%; "> -->
      <img src="../../public/3bg.png" alt="" style="width:100%; ">
      <!-- <img src="../../public/3bt.png" alt="" style="position:absolute;top:85%;left:50%;margin-left:-90px;width:180px;cursor: pointer;"> -->
    <!-- </div> -->
    <!-- <div style="position:relative;width:100%; "> -->
      <img src="../../public/4bg.png" alt="" style="width:100%; ">
      <!-- <img src="../../public/4bt.png" alt="" style="position:absolute;top:85%;left:25%;margin-left:-90px;width:180px;cursor: pointer;"> -->
    <!-- </div> -->
    <!-- <div style="position:relative;width:100%;    background: #292f33;"> -->
      <img src="../../public/5bg.png" alt="" style="width:100%;">
      <img src="../../public/5bt.png" alt="" style="position:absolute;top:95%;left:50%;margin-left:-25px;width:50px;cursor: pointer;">
    </div>

    
   
    <div class="phonenewblackdiv" style="background-color: #292f33;">
          <div style="display: flex;flex-direction: column;">
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Record Number:</div>
              <div v-else>备案号：</div>
              <div>粤ICP备2023152724号-1</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish" >Company:</div>
              <div  v-else>公司名：</div>
              <div  v-if="isEnglish" style="text-align: right;">Shenzhen Youdian Fun Technology Co.,Ltd</div>
              <div v-else >广州好好玩科技有限公司</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">Address：</div>
              <div  v-else>地址：</div>
              <div  v-if="isEnglish" style="text-align: right;">‌Room 807, Building 4, Chongwen Garden‌
‌Nanshan District, Shenzhen City, Guangdong Province, China</div>
              <div v-else>广州市天河区棠下荷光一横路1号406</div>
            </div>
            <div style="display: flex;    justify-content: space-between;margin: 5px;">
              <div  v-if="isEnglish">URL：</div>
              <div v-else>网址：</div>
              <div>www.fungamebox.cn</div>
            </div>
          </div>
       
      <div style="border: 0.1px solid #404040;    margin: 10px 0;"></div>
      <div v-if="isEnglish" class="bottom" style="font-size: 12px;margin-bottom: 20px;"> Record Number：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备2023152724号-1</a></div>

      <div v-else class="bottom" style="font-size: 12px;margin-bottom: 20px;"> 备案号：<a href="https://beian.miit.gov.cn/" style="color: #ffffff;">粤ICP备2023152724号-1</a></div>
    </div>

  </div>
 
</template>

<script>
 import MobileDetect from 'mobile-detect';
 import PhoneVideoBackground from './videophone.vue';
import VideoBackground from './video.vue';
export default {
  name: 'App',
  components: {
    VideoBackground,
    PhoneVideoBackground,
  },
  data() {
    return {
      isMobile: false,
      isEnglish: false,
      flag:0,
    };
  },
  mounted() {
    this.detectDevice();
  },
  methods: {
    detectDevice() {
      const md = new MobileDetect(window.navigator.userAgent);
      this.isMobile = md.mobile(); // 或者使用 md.tablet() 来检测平板设备
    },
    handleLanguageUpdate(newLanguage) {
      this.isEnglish = newLanguage
      // 处理语言切换逻辑，例如更新页面内容或调用其他方法
      console.log('Language updated:', newLanguage); 
    },
    handleWheel(event) {
      // 阻止默认滚动行为
      event.preventDefault();
      
      const delta = Math.sign(event.deltaY);
      const scrollAmount = window.innerHeight;
        // 添加平滑滚动效果
        window.scrollBy({
          top: delta * scrollAmount,
          behavior: 'smooth'
      });
      // 添加平滑滚动效果
     
    }
  }
};
</script>

<style>
.bottom{
    color: #ffffff;
  font-size: 14px;
      display: flex;
    justify-content: center;
}

.blackdiv{
  background: #1a1a1a;
  display: flex;
  padding: 100px 18%;
  justify-content: space-between;
 
}
.phoneblackdiv{
   background: #1a1a1a;
  display: flex;
  padding: 50px 18%;
  justify-content: space-between;
    flex-direction: column;
    align-items: center;
}
.newblackdiv{
    background: #1a1a1a;
  padding: 113px 18%;
  padding-bottom: 1vw;

}

.phonenewblackdiv{
    background: #1a1a1a;
  padding: 20px 18%;
  padding-bottom: 1vw;
  font-size: 12px;
  color: white;
}


  .midfontdes{
    font-size: 1.1rem;
    font-weight: 400;
    color: #999999 !important;
    padding: 50px 0  ;
  }
  .phoneidfontdes{
    font-size: 14px;
    font-weight: 400;
    color: #999999 !important;
    /* padding: 50px 0  ; */
  }
 .gamelistlogo{
  display: flex;
  padding-bottom: 100px;
 }
 .gamelistlogoinfo{
 width: 13vw;
 
  margin:15px;
 }
  .phonegamelistlogo{
  display: flex;
  padding-bottom: 60px;
  flex-wrap: wrap;
    width: 70vw;
 }
  .phonegamelistlogoinfo{
 width: 26vw;
 
  margin:15px;
 }
.yellowdiv{
  width: 100%;
  display: flex;
  background: #fac422;
  flex-direction: column;
    align-items: center
}

.rightphoto{
  position: absolute;
    left: 48%;
    top: 15vh;
    width: 50vw;
}
.fontdes{
 font-size: 1.125rem;
 font-weight: 400;
 color: #999999 !important;
  padding: 50px 50px 0 15vw;
}

.phonefontdes{
 font-size: 14px;
 font-weight: 400;
 color: #999999 !important;
  padding: 50px 50px 50px 15vw;
}

 

.fontpng{
      width: 25vw
}
.phonefontpng{
      width: 50vw
}
.imgphoto{
  padding: 25vh 20px 0 10vw;
  display: flex;
      justify-content: space-between;
}

.phoneimgphoto{
  padding: 5vh 20px 0 10vw;
  display: flex;
  justify-content: space-around;
}
.logopng{
     width: 10vw;
    height: 100%;
}
.phonelogopng{
     width: 18vw;
    height: 100%;
}
.topclass{
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
}
/* 根据需要添加全局样式 */
.topleft{
  background-color: #000000;
    width: 55%;
      height: 100%;
}

.phonetopleft{
  background-color: #000000;
}
.topright{
  background-color: #57bbff;
   width: 45%;
     height: 100%;
}

 

</style>
